import * as React from 'react';
import Moment from 'react-moment';
import { RouteComponentProps } from 'react-router';
import { Subscription, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import PredictionsService from '../../api/stadtbus/predictions_service';
import { IPrediction } from '../../interfaces/stadtbus/predictions'
import { lazyInject } from '../../inversify';
import './css/bustheme.css';
import { NightImage } from './line_images';
import { LemgoDigitalLogo, StadtbusLogo } from './stadtbus_logo';
import StopMap from './stop_map/stop_map';

interface IBusfahrerComponentProps extends Partial<RouteComponentProps<{}>> {
}

interface IBusfahrerComponentState {
  isLoading: boolean;
  nightMode: boolean,
  predictions: IPrediction[],
  showMap: boolean,
  wartenState: number
}

class BusfahrerComponent extends React.Component<IBusfahrerComponentProps, IBusfahrerComponentState> {

  private readonly TREFFPUNKT_ID: string = "2044";
  private readonly MAX_DELAY: number = 2;
  private readonly MAX_CYCLE_DELAY: number = 10;

  @lazyInject(PredictionsService)
  private readonly predictionsService: PredictionsService;

  private predictionsSubscription: Subscription;

  private cycleState: ICycleState[] = [];
  private allPredictions: IPrediction[] = [];
  
  constructor(props: IBusfahrerComponentProps) {
    super(props);

    this.state = {
      isLoading: true,
      nightMode: false,
      predictions: [],
      showMap: false,
      wartenState: 1
    };
  }

  public render() {
    if (this.state.nightMode) {
      if (!document.body.classList.contains("nightMode")) {
        document.body.classList.add("nightMode");
      }
    } else {
      if (document.body.classList.contains("nightMode")) {
        document.body.classList.remove("nightMode");
      }
    }

    const pjson = require('../../../package.json');

    const height = screen.height - 80;

    const stopMapParams: any = {
      isExact: true,
      params: {
        height: height + "px",
        lat: "52.028293",
        lng: "8.8947011",
        zoom: 18
      },
      path: undefined,
      url: undefined
    };

    return (
      <div className="page busfahrerFont" style={{ margin: "6px" }}>
        <div className="col-xs-9">
          <div style={{ marginBottom: '16px' }}>
            <div style={{ display: "inline" }}>
              Busse am Treffpunkt
            </div>
            <div style={{ display: "inline", paddingLeft: "8px", fontSize: "15px", color: "gray" }}>
              Pilotversion {pjson.version}
            </div>
          </div>
          {(this.state.showMap ? (
            <div className="stopMapTextSize">
              <StopMap match={stopMapParams}/>
            </div>
          ) : (
              <div>
                <div className="col-xs-12" style={{ margin: "6px", marginBottom: "0px", background: "black", color: "white" }}>
                  <div className="col-xs-2">
                    Linie
                </div>
                  <div className="col-xs-4">
                    Ziel
                </div>
                  <div className="col-xs-6">
                    Abfahrt
                </div>
                </div>
                {(this.state.predictions.length > 0) ? (
                  this.state.predictions.map((row: IPrediction) => (
                    <div className={"col-xs-12 respMarginTop " + this.getRowColor(row)} key={`${row.tripID}.${row.journeyRef}`} style={{ marginLeft: "6px", marginRight: "6px" }}>
                      <div className="col-xs-2">
                        {row.lineName}
                      </div>
                      <div className="col-xs-4">
                        {row.lineDestination}
                      </div>
                      <div className="col-xs-6">
                        <Moment format='HH:mm' date={row.shouldTime} /> ({this.formatDelay(row)})
                  </div>
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: "center" }}>
                      {(this.state.isLoading)?"Laden...":"Derzeit sind leider keine Informationen verfügbar."}                      
                  </div>
                  )}
              </div>
            ))}
        </div>
        <div className="col-xs-3">
          <LemgoDigitalLogo color={this.state.nightMode ? '#ffffff' : undefined} style={{display: 'block'}} width={'100%'}/>
          <StadtbusLogo style={{display: 'block'}} width={'100%'}/>
          <div className='col-xs-12'>
            <div className="col-xs-12" style={{ textAlign: 'center', fontSize: '32px' }} >
              <Moment interval={250} format={'HH:mm:ss'} />
            </div>
            <div className={"col-xs-12 wartenComponent " + this.wartenColor()}>
              {(this.state.wartenState === 1) ? 'Bitte fahren' : 'Bitte warten'}
            </div>
          </div>
          <div className='col-xs-12 respMarginTop'>
            <button className={"btn btn-primary buttonText"} onClick={e => this.switchNightMode()} title="Helligkeit ändern" style={{ width: "100%", color: "black" }}>
              <NightImage style={{width: '64px'}}/>
              <br />
              Helligkeit ändern
            </button>
          </div>
          <div className='col-xs-12 respMarginTop'>
            <button className={"btn btn-primary buttonText"} onClick={e => this.switchBetweenMapAndBusStop()} title="Helligkeit ändern" style={{ width: "100%", color: "black" }}>
              <span className="glyphicon glyphicon-map-marker busfahrerImage" />
              <br />
              {(!this.state.showMap ? "Karte anzeigen" : "Treffpunkt anzeigen")}
            </button>
          </div>
        </div >
      </div >
    );
  }

  public componentWillMount() {
    document.title = "Busfahrer App";

    this.predictionsSubscription = this.predictionsService
      .onStopPredictions(this.TREFFPUNKT_ID)
      .pipe(map((predictions: IPrediction[]) => { this.allPredictions = predictions; return predictions; }))
      .pipe(this.predictionsService.filterNextDeparturePerLine(this.MAX_CYCLE_DELAY))
      .subscribe((predictions: IPrediction[]) => {
        if (predictions.length > 0) {
          const currentCycle = predictions.reduce((min, p) => p.shouldTime < min ? p.shouldTime : min, predictions[0].shouldTime);

          // Filter predictions by current cycle
          predictions = predictions.filter((p => p.shouldTime.getTime() === currentCycle.getTime()));
        }

        this.setState({
          isLoading: false,
          predictions,
          wartenState: this.calculateWarteState(predictions)
        });
      }, () => {
        this.setState({isLoading: false});
      });

    timer(0, 500).subscribe(() => {
      const state = this.calculateWarteState(this.state.predictions);
      if (this.state.wartenState !== state) {
        this.setState({ wartenState: state });
      }
    });
  }

  public componentWillUnmount() {
    this.predictionsSubscription.unsubscribe();
  }

  private formatDelay(prediction: IPrediction) {
    if (!prediction.isRealTime) {
      return 'keine Daten';
    } else if (prediction.delay <= 0) {
      return 'pünktlich';
    } else if (prediction.delay === 1) {
      return "+" + prediction.delay + " Minute";
    } else {
      return "+" + prediction.delay + " Minuten";
    }
  }

  private switchBetweenMapAndBusStop() {
    this.setState({ showMap: !this.state.showMap });
  }

  /**
   * @returns 1 = bitte fahren, 2 = bitte warten (gelb), 3 = bitte warten (rot)
   */
  private calculateWarteState(predictions: IPrediction[]): number {
    // Wenn keine Informationen angezeigt werden
    if (predictions.length === 0) {
      return 1;
    }

    const now = new Date();

    // Planned departure of current cycle 
    const currentCycle = predictions.reduce((min, p) => p.shouldTime < min ? p.shouldTime : min, predictions[0].shouldTime);
    
    // Predictions of current cycle
    const currentCyclePredictions: IPrediction[] = predictions.filter((p => p.shouldTime.getTime() === currentCycle.getTime()));

    // Get cycle state of current cycle (Wenn 884 nochmal durchfährt taucht sie in den IVU Daten wieder auf)
    let currentCycleState = this.cycleState.find(c => currentCycle.getTime() === c.time.getTime());
    if (!currentCycleState) {
      currentCycleState = { time: currentCycle, state: 3 };
      this.cycleState.push(currentCycleState);
    }

    // If cycle planned time is reached, go in "please wait for small delayed busses" state
    if (currentCycleState.state === 3 && now >= currentCycle) {
      currentCycleState.state = 2;
    }
    // If no small delayed busses are left, go in "please drive" state
    if (currentCycleState.state === 2 && currentCyclePredictions.filter(p => p.delay <= this.MAX_DELAY && p.estimatedTime! > now).length === 0) {
      currentCycleState.state = 1;
    }
    // If "Viertelstundentakt", go in "please drive" state
    if (currentCycleState.state === 2 && this.isQuarterOfAnHour(currentCycle, this.allPredictions)) {
      currentCycleState.state = 1;
    }

    return currentCycleState.state;
  }
  
  private isQuarterOfAnHour(time: Date, predictions: IPrediction[]) {
    // distinct cycles
    const uniqueCycles: Date[] = [];
    predictions.map(p => p.shouldTime).forEach((value) => {
      if(uniqueCycles.filter((value2) => value.getTime() === value2.getTime()).length === 0) {
        uniqueCycles.push(value);
      }
    });
    // sort
    uniqueCycles.sort();
    let indexOfCycle = -1;
    for (let i = 0; i < uniqueCycles.length; i++) {
      if(uniqueCycles[i].getTime() === time.getTime()){
        indexOfCycle = i;
      }
    }
    if(indexOfCycle >= uniqueCycles.length){
      return false;
    }
    const timeBetween = uniqueCycles[indexOfCycle + 1].getTime()/60000 - time.getTime()/60000;
    return timeBetween <= 15;
  }

  private switchNightMode() {
    this.setState({ nightMode: !this.state.nightMode });
  }

  private getRowColor(prediction: IPrediction) {
    if(!prediction.isRealTime) {
      return 'ampelGrey';
    } else if (prediction.delay <= 0) {
      return 'ampelGreen';
    } else if (prediction.delay <= this.MAX_DELAY) {
      return 'ampelYellow';
    } else {
      return 'ampelRed';
    }
  }

  private wartenColor() {
    if (this.state.wartenState === 1) {
      return "ampelGreen";
    } else {
      return "ampelRed";
    }
  }

}

export default BusfahrerComponent;

interface ICycleState {
  time: Date,
  state: number
}



// WEBPACK FOOTER //
// ./src/components/stadtbus/busfahrer_component.tsx